import { CheckCircleRounded, InfoRounded } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import React from "react";
import RpAlert from "@/components/alerts/RpAlert";
import {
  isTemporarilyClosedLocation,
  TemporaryClosedStatusNote as TemporaryClosedStatusNoteBase,
} from "@/components/muiCustom/note/InlineStatusNote";

type ExtendLocation = {
  location_name?: string;
  location_status?: number | string;
  reopening_date?: string;
  [key: string]: unknown;
};

type ExtendLocationFormData = {
  can_update_creatives?: boolean;
  extend_creatives?: Array<number | string>;
  extend_start_date?: string;
  extend_end_date?: string;
  extend_budget?: string | number;
};

type ExtendLocationCreativeHeaderProps = {
  loc: ExtendLocation;
  lc?: ExtendLocationFormData | null;
};

const TemporaryClosedStatusNote =
  TemporaryClosedStatusNoteBase as React.ComponentType<Record<string, any>>;

function ExtendLocationCreativeHeader({
  loc,
  lc,
}: ExtendLocationCreativeHeaderProps) {
  const renderIcon = () => {
    if (!lc?.can_update_creatives) {
      return <InfoRounded color="error" />;
    }

    const isCreativeSelected = lc?.can_update_creatives
      ? lc?.extend_creatives?.length
      : true;
    const isAllFilled =
      lc.extend_start_date &&
      lc.extend_end_date &&
      lc.extend_budget &&
      isCreativeSelected;

    if (isAllFilled) {
      return <CheckCircleRounded color="primary" />;
    }
    return <InfoRounded color="error" />;
  };

  const renderMessage = () => {
    if (!lc?.can_update_creatives) {
      return (
        <RpAlert severity="error" sx={{ fontSize: 12, py: 0 }}>
          Extension shorter than the minimum duration required for creative
          update
        </RpAlert>
      );
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        width: "100%",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
        {renderIcon()}
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 700 }}>
            {loc.location_name}
          </Typography>
          {isTemporarilyClosedLocation(loc) ? (
            <Box sx={{ mt: 1 }}>
              <TemporaryClosedStatusNote location={loc} />
            </Box>
          ) : null}
        </Box>
      </Box>
      <Box>{renderMessage()}</Box>
    </Box>
  );
}

export default ExtendLocationCreativeHeader;
